import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false,
})
export class HomeComponent implements OnInit {
    constructor() {}

    // images = [
    //     './assets/media/products/bannerOne.webp',
    //     '/assets/media/products/bannerTwo.webp',
    //     '/assets/media/products/bannerThree.webp',
    //     '/assets/media/products/bannerFour.webp',
    // ];
    ngOnInit(): void {}
}
